export default "main{height:100%;}";